// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "loyalty_switch-nvHZG";
var _5 = "loyalty__desc-17qes";
var _6 = "loyalty_switch_open-3xJoB";
var _7 = "loyalty-1nwqs";
var _8 = "container_loyalty-1j2Rw";
var _9 = "withIcons-1Dmb3";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "loyalty_switch", _5 as "loyalty__desc", _6 as "loyalty_switch_open", _7 as "loyalty", _8 as "container_loyalty", _9 as "withIcons" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "loyalty_switch": _4, "loyalty__desc": _5, "loyalty_switch_open": _6, "loyalty": _7, "container_loyalty": _8, "withIcons": _9 }
